import BatchType from "../../../types/Batch";
import ProjectType from "../../../types/Project";
import { HomepageProject } from "../widgets/types";

export const batchMapper = (batch: BatchType) => ({
  ...batch,
  projectName: batch.project.name,
  labelerStr: batch.labeler
    ? `${batch.labeler.lastName} ${batch.labeler.firstName}`.trim()
    : "<non attribué>",
  labelerId: batch.labeler ? batch.labeler.id : undefined,
});

export const projectMapper = (project: ProjectType): HomepageProject => ({
  ...project,
  clientName: project.client?.name ?? "",
  labelingType: project.labelingTypes?.[0]?.name ?? "",
});
